import { usePendingOrganizationInvitations } from "@/api";
import { TypographyXS } from "@/components/typography/XS";
import { Button } from "@/components/ui/button";
import Card from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { ComponentProps } from "react";

export function PendingInvitationCard({
  className,
  ...props
}: ComponentProps<typeof Card>) {
  const { data, loading, error } = usePendingOrganizationInvitations();

  if (error) {
    console.error(
      "Error fetching user pending organization invitations: ",
      error
    );
    return null;
  }

  if (loading || data.length < 1) return null;

  return (
    <Card {...props} className={cn("w-full p-4 flex items-center", className)}>
      <TypographyXS>
        You&apos;ve got {data.length} pending organization invitation
        {data.length === 1 ? "" : "s"}.
      </TypographyXS>
      <Link to="/invitations">
        <Button variant="secondary">
          Invitations
          <ArrowRight size={14} className="ml-2" />
        </Button>
      </Link>
    </Card>
  );
}
